import css from 'styled-jsx/css';

export default css`.suggest-list-inner {
        border-top: 1px solid #D8D8D8;
        padding: 12px 0;
        .suggest-list-item {
          display: block;
          color: #000000;
          line-height: 20px;
          padding: 5px 16px;
          font-size: 14px;
          cursor: pointer;
          :global(.em){
            color: #FF6400;
          }
        }
        .suggest-list-item:hover {
          background: #F5F5F5;
        }
        .suggest-list-item:hover {
          color: #FF6400;
          :global(.em) {
            color:  #FF6400 !important;
          }
        }
      }`